import React from 'react';
import { useNavigate } from 'react-router-dom';
import SoftModeGame from '../components/SoftModeGame';
import CardGame from '../components/CardGame';
import DebatWheel from '../components/DebatWheel';
import CoquinModeGame from '../components/CoquinModeGame';
import { useGameLogic } from '../hooks/useGameLogic';
import type { GameMode } from '../hooks/useGameLogic';

import { softActions, softTuPreferes, softBattles } from '../data/soft';
import { hardQuestions, hardActions } from '../data/hard';
import { societePolitique, moralEthique, relationnelPerso, wtfDecale, soireeHot } from '../data/debat';

const debatCategories = [
  { name: 'Société/Politique', color: '#10B981', icon: '🏛️', questions: societePolitique },
  { name: 'Moral/Éthique', color: '#166534', icon: '⚖️', questions: moralEthique },
  { name: 'Relationnel/Perso', color: '#4ADE80', icon: '💬', questions: relationnelPerso },
  { name: 'WTF/Décalé', color: '#6EE7B7', icon: '⚡', questions: wtfDecale },
  { name: 'Soirée/Hot', color: '#84CC16', icon: '💋', questions: soireeHot },
];

interface GameProps {
  mode: GameMode;
  players: string[];
}

export default function Game({ mode, players }: GameProps) {
  const navigate = useNavigate();

  const data = mode === 'hard' ? { questions: hardQuestions, actions: hardActions } : { questions: [], actions: [] };
  const {
    currentPlayer,
    currentChoice,
    currentContent,
    isCardFlipped,
    turnCount,
    flipCard,
    chooseType,
    nextTurn,
  } = useGameLogic(players, data.questions, data.actions);

  return (
    <div className="relative">
      {/* Back button */}
      <button
        onClick={() => navigate('/select')}
        className="absolute left-6 z-50 w-10 h-10 rounded-full bg-black/30 backdrop-blur-md flex items-center justify-center text-white/60 btn-press border border-white/10"
        style={{ top: 'max(env(safe-area-inset-top, 0px) + 8px, 24px)' }}
      >
        ←
      </button>

      {mode === 'soft' && (
        <SoftModeGame
          players={players}
          actions={softActions}
          tuPreferes={softTuPreferes}
          battles={softBattles}
        />
      )}

      {mode === 'hard' && (
        <CardGame
          mode={mode}
          currentPlayer={currentPlayer}
          isCardFlipped={isCardFlipped}
          currentChoice={currentChoice}
          currentContent={currentContent}
          onFlipCard={flipCard}
          onChooseType={chooseType}
          onNextTurn={nextTurn}
          turnCount={turnCount}
        />
      )}

      {mode === 'roulette' && (
        <DebatWheel
          players={players}
          categories={debatCategories}
        />
      )}

      {mode === 'coquin' && (
        <CoquinModeGame players={players} />
      )}
    </div>
  );
}
